var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "checkbox checkbox-custom",
      class: { "checkbox-inline": _vm.inline === 1 },
    },
    [
      _c(
        "label",
        [
          _c("input", {
            attrs: { name: _vm.id, id: _vm.id, type: "checkbox" },
            domProps: { checked: _vm.value, value: _vm.val },
            on: { change: _vm.triggerEvent },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "checkbox-custom-btn" }),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm.aria
            ? _c("span", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.aria))])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.modal
        ? _c("div", [
            _c(
              "a",
              {
                attrs: {
                  href: "#",
                  "data-bs-toggle": "modal",
                  "data-bs-target": _vm.modalId,
                },
              },
              [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("ic_wiecej_info_rodo")),
                  },
                }),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }